// @ts-nocheck
// import Control from 'react-leaflet-control';
import '@geoman-io/leaflet-geoman-free';
import { useLeafletContext } from '@react-leaflet/core';
import L from 'leaflet';
import 'leaflet-toolbar';
import { useEffect } from 'react';
import ReactDOMServer from 'react-dom/server';
import { useIntl } from 'react-intl';
import Icon from 'utility/icomoon';

export interface TrackUnitWindowOptions {
  useToolbar: boolean;
  listenMapControlChanges?: any[];
  position?: 'topleft' | 'topright' | 'bottomleft' | 'bottomright';
}

/* -------------------------------------------------------------------------- */
/*                         ToolbarTrackUnitWindow                             */
/* -------------------------------------------------------------------------- */

const ToolbarTrackUnitWindow = (props: UnitActiveTrackingOptions) => {
  const { useToolbar, position = 'topleft', listenMapControlChanges } = props;

  const context = useLeafletContext();
  const intl = useIntl();

  useEffect(() => {
    const container = context.layerContainer || context.map;
    try {
      var ImmediateSubAction = L.Toolbar2.Action.extend({
        initialize: function (map, myAction) {
          this.map = map;
          this.myAction = myAction;
          L.Toolbar2.Action.prototype.initialize.call(this);
        },
        addHooks: function () {
          this.myAction.disable();
        }
      });

      var activeTimer = L.Toolbar2.Action.extend({
        options: {
          toolbarIcon: {
            tooltip: intl.formatMessage({ id: 'map.trackUnitWindowToolbar.tooltipOpenWindow' }),
            html: ReactDOMServer.renderToStaticMarkup(
              <>
                <Icon size={18} icon="Monitor" />
              </>
            )
          }
        },
        addHooks: () => {
          window.open(
            `/track`,
            '_blank',
            'width=800,height=600,top=100,left=100,resizable=yes,scrollbars=yes'
          );
        },
        disable: function (e) {
          L.Toolbar2.Action.prototype.disable.call(this);
        }
      });

      L.Toolbar2.TrajectoryToolbar = L.Toolbar2.Control.extend({
        options: {
          actions: [activeTimer]
        }
      });

      var timerToolbar = new L.Toolbar2.TrajectoryToolbar({ position: position });
      timerToolbar.addTo(container);

      return () => {
        timerToolbar.remove();
      };
    } catch {}
  }, [...listenMapControlChanges]);
  return null;
};

ToolbarTrackUnitWindow.defaultProps = {
  postion: 'topleft',
  listenMapControlChanges: []
};

export default ToolbarTrackUnitWindow;
